import { routeName } from "../utils";
import pageConfig from "@/config/page";
const page = pageConfig.pages.activity;
const name = "activity";

export default {
    name: name,
    path: name,
    meta: {
        disable: true,
    },
    component: () => import("@/layout/routerView"),
    children: [
        {
            name: routeName("record", name),
            path: "record",
            redirect: { name: routeName("record.index", name) },
            component: () => import("@/layout/routerView"),
            children: [
                {
                    name: routeName("record.index", name),
                    path: "",
                    component: page.record.board,
                },
                {
                    name: routeName("record.agent", name),
                    path: ":activity_id",
                    component: page.record.agent,
                },
                {
                    name: routeName("record.detail", name),
                    path: ":activity_id/:target_name",
                    component: page.record.detail,
                },
            ],
        },
        {
            name: routeName("member_search", name),
            path: "member_search",
            component: page.member_search,
        },
    ],
};
